<ion-header class="select-single-option-mdl">
    <div>
        <ion-col class="select-topbar">
            <p class="select-title ion-text-center">{{ title }}</p>
            <!-- <ion-icon name="close" tappable (click)="closeModal()"></ion-icon> -->
        </ion-col>
    </div>
</ion-header>

<!-- <ion-content class="background-white"> -->
<div>
    <div class="ion-no-padding select-modal">
        <div class="select-container">
            <div class="dropdown-list-holder">
                <ul class="dropdown-list" *ngIf="options && options.length > 0" [ngClass]="options && options.length > 5 ? 'more-options' : ''">
                    <li
                        *ngFor="let item of options"
                        class="dropdown-list-item"
                        (click)="optionSelect(item)"
                        [ngClass]="(selectedObj && item.value == selectedObj.value) || item.value == selectedObj ? 'selected' : ''"
                    >
                        {{ item?.name }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
<!-- </ion-content> -->

<ion-footer class="select-single-option-mdl">
    <ion-row>
        <ion-col class="footer">
            <ion-button type="button" fill="outline" color="secondary" (click)="closeModal()"> Cancel </ion-button>

            <ion-button type="button" color="secondary" (click)="submit()"> Select </ion-button>
        </ion-col>
    </ion-row>
</ion-footer>
